import { useAuth } from '../../context/AuthContext';
import SuperAdminDashboard from './SuperAdminDashboard';
import RetailOUDashboard from './RetailOUDashboard';
import CounsellorDashboard from './CounsellorDashboard';

const DashboardPage = () => {
  const { user } = useAuth();
  const code = user?.role?.code;

  if (code === 'RETAIL_OU_LEAD') return <RetailOUDashboard />;
  if (code === 'COUNSELLOR') return <CounsellorDashboard />;
  return <SuperAdminDashboard />;
};

export default DashboardPage;
